import { getConfig } from '../config';
import { request } from '../helpers/request';

const url = `${getConfig().apiUrl}/users/phone`;

/**
 *
 * @param apiKey
 * @param email
 * @returns
 * @description: post email to get otp on the user's email
 */
export function postOTPPhone(apikey: string, phone: string,iso_code:string, language: string): any {
	return request({
		method: 'POST',
		url,
		queryParams:{
			language
		},
		body: {
			phone,
			iso_code
		},
		headers: {
			'X-API-Key': apikey,
		},
	});
}
